import { locales } from './locales.util';

export function formatPercent(
  percent: number,
  maximumSignificantDigits = 2,
): string {
  return new Intl.NumberFormat(locales['fr-FR'], {
    style: 'percent',
    maximumSignificantDigits,
  }).format(percent / 100);
}
